import { Carousel } from "bootstrap";

const Forms = () => {
    const returnObj = {};
    /**
     * Auto-Resize textarea
     */
    returnObj.autoResizeTextarea = function (hash) {
        var $textAreas = jQuery(hash);

        $textAreas.each(function (i, $element) {
            if (!!$element) {
                $element.addEventListener('keyup', function () {
                    this.style.overflow = 'hidden';
                    this.style.height = 0;
                    this.style.height = this.scrollHeight + 'px';
                }, false);
            }
        });
    };

    /**
     * toggle visibility of the help block
     * @param hash
     */
    returnObj.toggleVisibilityHelpBlock = function (hash) {
        jQuery(hash).focusin(function () {
            jQuery(this).parent().find('.help-block').fadeIn();
        });
        jQuery(hash).focusout(function () {
            jQuery(this).parent().find('.help-block').fadeOut();
        });
    };

    /**
     * add a clean-button into input-field
     */
    returnObj.clearInputButton = function ($selector) {
        if (!$selector) {
            $selector = jQuery(document);
        } else if (!($selector instanceof $)) {
            $selector = jQuery($selector);
        }
        var firstKeyUp = false;
        $selector.find('.input-clear').keyup(function () {
            jQuery(this).parent().parent().find('.clear-icon-input').toggle(Boolean(jQuery(this).val()))
            if (!firstKeyUp) {
// 				returnObj.fixClearButton();
                firstKeyUp = true;
            }
        });

        $selector.find('.clear-icon-input').each(function (i, e) {
            jQuery(e).toggle(Boolean(jQuery(e).prev().val()));
        });

        $selector.find('.clear-icon-input').on('click', function () {
            jQuery(this).parent().find('input').val('');
            jQuery(this).parent().parent().parent('.fixed-table-toolbar').find('input').keyup();
            jQuery(this).toggle(false);
        });
    };

    /**
     * fix with .input-group-btn
     //     */
// 	returnObj.fixClearButton = function() {
// 		jQuery('.clear-icon-input').each(function () {
// 			var inputWidth = jQuery(this).parent().find('input').outerWidth();
// 			inputWidth -= (jQuery(this).outerWidth() / 2);
//
// 			if (!!inputWidth) {
// 				jQuery(this).css('left', inputWidth);
// 			}
// 		});
// 	};

    /**
     * coloring the input button
     */
    returnObj.coloringInputButtons = function () {
        const feedBackInput = jQuery('form .has-feedback input');
        feedBackInput.focusin(function () {
            jQuery(this).next().addClass('link-style');
        });
        feedBackInput.focusout(function () {
            jQuery(this).next().removeClass('link-style');
        });
    };

    /**
     * loading icon for typeahead (search-forms)
     * @param hash
     * @param html
     */
    // returnObj.typeaheadLoading = function(hash, html) {
    // 	var $hash = jQuery(hash) || false;
    // 	var html = html || false;
    //
    // 	if(!!$hash) {
    // 		var $btn = $hash.parent().next('.btn');
    // 		var $searchBtn = $hash.parent().next('button');
    // 		var $cleanBtn = $hash.parent().parent().find('.clear-icon-input');
    //
    // 		if(!!html.length) {
    // 			$btn.html(html);
    // 		}
    // 		else {
    // 			$btn.children('.tt-spinner').remove();
    // 		}
    //
    // 		$searchBtn.toggleClass('glyphicons-search');
    // 		$cleanBtn.toggleClass('glyphicons-remove-2');
    // 	}
    // };


    returnObj.stopCarouselSlideonFocus = function () {
        jQuery('[type="search"]').focus(function () {
            [...jQuery('.carousel').get()].map(element => {
                Carousel.getOrCreateInstance(element).pause();
            });
        }).blur(function () {
            [...jQuery('.carousel').get()].map(element => {
                Carousel.getOrCreateInstance(element).cycle();
            });
        });
    };

    /**
     * inital action - started if page load finish
     */
    jQuery(function () {
        returnObj.autoResizeTextarea('.resize-auto');
        returnObj.toggleVisibilityHelpBlock('.help-block-hidden');
        returnObj.clearInputButton();
        returnObj.coloringInputButtons();
        returnObj.stopCarouselSlideonFocus();
    });

    return returnObj;
}
export const forms = Forms();
